import {layoutInteractionType} from "../../../actions/layout/interaction/type";


const initialState = {
    actions: null,
    headerTitle: null,
    collapsed: false,
    screenWidth: false,

    filter: null,
    page: 1,
    pageSize: 8,
    search: null,
    sort: null,
    uploadFileProgress: null,
    filterMenu: null,
    visibleDrawer: false,
    reloadData: false,
    visibleModal: false,

    object: {},

    repeatText: {},

    isAdmin: false,
    isSettingSider: false,
    reloadDataButtonProcess: ''
};
const layoutInteractionReducer = (state = initialState, action) => {
    switch (action.type) {
        case layoutInteractionType.SET_ACTIONS:
            return {
                ...state,
                actions: action.params
            }
        case layoutInteractionType.ON_CHANGE_UPLOAD_FILE_PROGRESS:
            return {
                ...state,
                uploadFileProgress: action.params
            }
        case layoutInteractionType.SET_HEADER_TITLE:
            return {
                ...state,
                headerTitle: action.params
            };
        case layoutInteractionType.CHANGE_COLLAPSED_SIDER:
            return {
                ...state,
                collapsed: action.params == null ? !state.collapsed : action.params
            }
        case layoutInteractionType.CHANGE_SEARCH:
            return {
                ...state,
                search: action.params
            }
        case layoutInteractionType.ON_CLICK_FILTER:
            return {
                ...state,
                filter: action.filter
            }
        case layoutInteractionType.SET_FILER_MENU:
            return {
                ...state,
                filterMenu: action.filerMenu
            }
        case layoutInteractionType.SET_HEADER:
            return {
                ...state,
                headerTitle: action?.headerTitle ? action.headerTitle : null,
                filterMenu: action?.filerMenu ? action.filerMenu : null,
                reloadData: false,
                object: {}

            }
        case layoutInteractionType.ON_CHANGE_VISIBLE_DRAWER:
            return {
                ...state,
                visibleDrawer: action?.params ? action.params : !state.visibleDrawer
            }

        case layoutInteractionType.ON_RELOAD_DATA:
            return {
                ...state,
                reloadData: action.params
            }

        case layoutInteractionType.ON_UPDATE_CLICK:
            return {
                ...state,
                updateClick: action?.params ? action.params : !state.updateClick,
                updateData: action.data
            }

        case layoutInteractionType.ON_CHANGE_VISIBLE_MODAL:
            return {
                ...state,
                visibleModal: action?.params ? action.params : !state.visibleModal

            }
        case layoutInteractionType.ON_PAGINATION_CHANGE:
            return {
                ...state,
                page: action.page !== null ? action.page : state.page,
                pageSize: action.pageSize !== null ? action.pageSize : state.pageSize,
            }
        case layoutInteractionType.ON_SORTER_CHANGE:
            return {
                ...state,
                sort: action.sorter
            }
        case layoutInteractionType.ON_CHANGE_SUCCESS_AXIOS:
            return {
                ...state,
                success: action.params
            }
        case layoutInteractionType.ON_CHANGE_OBJECT:
            return {
                ...state,
                object: {
                    ...state.object,
                    ...action.object
                }
            }
        case layoutInteractionType.ON_PAGINATION_SORT_CHANGE:
            return {
                ...state,
                sort: action.sort,
                page: action.page,
                pageSize: action.pageSize
            }
        case layoutInteractionType.ON_CHANGE_REPEAT_TEXT:
            return {
                ...state,
                repeatText: {
                    ...action.repeatText
                }
            }
        case layoutInteractionType.ON_CHANGE_SCREEN_WIDTH:
            return {
                ...state,
                screenWidth: action.screenWidth
            }

        case layoutInteractionType.CHECK_ADMIN:
            return {
                ...state,
                isAdmin: action.checkAdmin
            }
        case layoutInteractionType.CHANGE_SETTING_SIDER:
            return {
                ...state,
                isSettingSider: action.isSettingSider
            }
        case layoutInteractionType.RELOAD_DATA_BUTTON_PROCESS:
            return {
                ...state,
                reloadDataButtonProcess: action.reloadData
            }
        default:
            return state;
    }
};

export default layoutInteractionReducer;
